<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/zhtsgbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'昂克HiSeat选好座'" ></detailBread>
         <div class="container">
            <div class="page-title">
                昂克HiSeat选好座
            </div>
            <div class="page-content">
                <video src=".../../../static/images/zwyy.mp4" width="100%" controls="controls">
                    当前浏览器不支持播放视频，请使用Chrome浏览器或IE最新版本打开
                </video>
                <div class="clearfix"></div>
                <img src="../../../static/images/20200518-01.png" alt="" style="float:left;width:auto;height: 50px;margin-top: 20px;margin-bottom:20px;" />
                <div class="clearfix"></div>
                <img src="../../../static/images/20200518-1.png" width="80%" alt="" />
                <img src="../../../static/images/20200518-2.png" width="80%" alt="" />
                <div class="clearfix"></div>
                <img src="../../../static/images/20200518-02.png" alt="" style="float:left;width:auto;height: 50px;margin-top: 20px;margin-bottom:20px;" />
                <div class="clearfix"></div>
                <img src="../../../static/images/20200518-3.png" width="80%" alt="" />
                 <div class="clearfix"></div>
                <img src="../../../static/images/20200518-03.png" alt="" style="float:left;width:auto;height: 50px;margin-top: 20px;margin-bottom:20px;" />
                 <div class="clearfix"></div>
                <img src="../../../static/images/20200518-4.png" width="80%" alt="" />
                 <div class="clearfix"></div>
                <img src="../../../static/images/20200518-04.png" alt="" style="float:left;width:auto;height: 50px;margin-top: 20px;margin-bottom:20px;" />
                 <div class="clearfix"></div>
                <img src="../../../static/images/20200518-5.png" width="80%" alt="" />
                 <div class="clearfix"></div>
                <img src="../../../static/images/20200518-05.png" alt="" style="float:left;width:auto;height: 50px;margin-top: 20px;margin-bottom:20px;" />
                 <div class="clearfix"></div>
                <img src="../../../static/images/20200518-6.png" width="80%" alt="" />
                 <div class="clearfix"></div>
                <img src="../../../static/images/20200518-06.png" alt="" style="float:left;width:auto;height: 50px;margin-top: 20px;margin-bottom:20px;" />
                 <div class="clearfix"></div>
                <img src="../../../static/images/20200518-7.png" width="80%" alt="" />
                <img src="../../../static/images/2018120504.jpg" width="80%" alt="" >
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '昂克HiSeat选好座', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '昂克HiSeat选好座'
        },
        {
            name: 'description',
            content: '昂克HiSeat选好座'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'2',
            blackTabsNum:'1'
        }
    },
    methods: {
        topback(){
            window.localStorage.setItem('blackTabsNum',1)
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/old/zwyy.vue